export class ProductRider {
  name = ''
  benefit_amount = ''
  premium: number = undefined
  ncp = ''
  effective_date: number = undefined
  expiry_date: number = undefined
  duration = ''
}
